import React from "react";
import { CandybarItemConfigType, CandybarItemOptionType, CandybarItemType } from "./types";
import styled from "styled-components";
import { centsToCurrencyString } from "../../../utils/numbers";
import CandybarItemConfigs from "./CandybarItemConfigs";

const Option = styled.li<{disabled?: boolean}>`
    cursor: pointer;
    margin-bottom: 1em;

    ${props => props.disabled && 'opacity: 0.5;'}

    & > input[type="radio"],
    & > input[type="checkbox"] {
        margin-bottom: 0.25em;
        margin-right: 1em;
        vertical-align: middle;
    }
`

interface Props {
    config: CandybarItemConfigType,
    multiple: boolean,
    onOptionSelect: Function,
    option: CandybarItemOptionType,
    unitConfig?: Array<number|string>,
    unitConfigs: object|null,
}

function CandybarItemOption(props:Props) {
    const { config, multiple, onOptionSelect, option, unitConfig, unitConfigs } = props;
    const selected = unitConfig && (unitConfig.indexOf(option.id) > -1);
    
    return <React.Fragment>
        <Option key={option.id} onClick={() => onOptionSelect(config, option, !selected)}>
            <input type={multiple ? 'checkbox' : 'radio'} name={`item-config-option-${config.id}`} checked={selected}/>
            {option.name}
            {option.price > 0 && <span> + {centsToCurrencyString(option.price)}</span>}
        </Option>
    </React.Fragment>;
}

export default CandybarItemOption;